'use client'
import { useLang } from '../../context/LangContext'
import { t, productBackup } from '../../lib/translations'
import ProductLanding from '../../components/ProductLanding'
import Icon from '../../components/Icon'

const featureIcons = ['clock', 'globe', 'shield', 'refresh', 'layers', 'shield-check', 'refresh', 'transfer'] as const

export default function BackupPage() {
  const lang = useLang()
  const features = productBackup.features.map((f, i) => ({
    title: t(lang, f.title),
    description: t(lang, f.description),
    icon: <Icon name={featureIcons[i]} className="w-6 h-6" strokeWidth={1.5} />,
  }))
  const benefits = productBackup.benefits.map((b) => ({ title: t(lang, b.title), desc: t(lang, b.desc) }))

  return (
    <ProductLanding
      id="backup"
      title={t(lang, productBackup.title)}
      subtitle={t(lang, productBackup.subtitle)}
      description={t(lang, productBackup.description)}
      heroBg="bg-gradient-to-b from-[#6366f1]/5 via-transparent to-transparent"
      heroGlow="bg-[#818cf8]/10"
      features={features}
      benefits={benefits}
    />
  )
}
